<h3> COMMITTEE </h3>
<h4> CHAIRS </h4>
<p>The Chairs of CIFRIS24 are:</p>
<ul>
	<li> Luca De Feo (IBM Research Zurich - Switzerland) </li>
	<li> Barbara Masucci (University of Salerno - Italy) </li>
</ul>
<br>
<h4> PROGRAM COMMITTEE MEMBERS </h4>
<ul>
	<li> Christian Badertscher (Input Output - Switzerland) </li>
	<li> Charles Bouillaguet (Sorbonne University LIP6 Paris - France) </li>
	<li> Marco Calderini (University of Trento - Italy) </li>
	<li> Claude Carlet (Univ. of Paris 8 - France and Univ. of Bergen - Norway) </li>
	<li> Michele Ciampi (University of Edinburgh - Scotland) </li>
	<li> Roberto Civino (University of L’Aquila - Italy) </li>
	<li> Miranda Christ (Columbia University - USA) </li>
	<li> Anna Lisa Ferrara (University of Molise - Italy) </li>
	<li> Tako Boris Fouotsa (EPFL - Switzerland) </li>
	<li> Danilo Francati (Aarhus University - Denmark) </li>
	<li> Daniele Friolo ("Sapienza" University of Rome - Italy) </li>
	<li> Philippe Gaborit (University of Limoges - France) </li>
	<li> Annamaria Iezzi (Université Grenoble Alpes - France) </li>
	<li> Delaram Kahrobaei (New York University - USA) </li>
	<li> Elena Kirshanova (Baltic Federal University - Russia) </li>
	<li> Nian Li (Hubei University - China) </li>
	<li> Atul Mantri (Virginia Tech - USA) </li>
	<li> Sihem Mesnager (University of Paris VIII - France) </li>
	<li> Giacomo Micheli (University of South Florida - USA) </li>
	<li> Marine Minier (Université de Lorraine - France) </li>
	<li> Alice Pellet-Mary (IMB - France) </li>
	<li> Svetla Petkova-Nikova (KU Leuven - Belgium) </li>
	<li> Alberto Ravagnani (The Eindhoven University - The Netherlands) </li>
	<li> Divya Ravi (University of Amsterdam - Netherlands) </li>
	<li> Simona Samardjiska (Radboud University - The Netherlands)</li>
	<li> Santanu Sarkar (Indian Institute of Technology Madras - India) </li>
	<li> Luisa Siniscalchi (Danmarks Tekniske Universitet (DTU) - Denmark) </li>
	<li> Claudio Soriente (NEC Laboratories Europe Madrid - Spain) </li>
	<li> Pantelimon Stanica (Naval Postgraduate School - USA) </li>
	<li> Serge Vaudenay (EPFL - Switzerland) </li>
	<li> Polina Vinogradova (IOHK - Canada) </li>
	<li> Hendrik Waldner (Max Planck Institute - Germany) </li>
</ul>